import { GrupEkleGuncellePage } from './../grup-ekle-guncelle/grup-ekle-guncelle';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';

/**
 * Generated class for the GrupListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-grup-listesi',
  templateUrl: 'grup-listesi.html',
})
export class GrupListesiPage {
  aranan="";
  skip:number=0;
  take:number=100;
  GrupListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra();
  }
  kayitAra() {

    this.bllOrtak.islemWithoutPost("CariGrupListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.GrupListesi = sonuc.SonucObject;
   
   
 
    })
  }
  

  yenikayit() {
    let modal = this.modalCtrl.create(GrupEkleGuncellePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(grup){
    let modal = this.modalCtrl.create(GrupEkleGuncellePage, { grupVw: grup });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  }
  GrupSil(grup) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", grup.ID);

      this.bllOrtak.islem(formData, "GrupSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra();
     
    })
   
  }
  Islemler(grup) {
    const actionSheet = this.actionSheetCtrl.create({
      title: grup.Name,
      buttons: [
        {
          text: 'Sil',

          handler: () => {
            this.GrupSil(grup);
          }

        },
        {
          text: 'Düzenle',
          handler: () => {
            this.kayitduzenle(grup);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/CariGrupIslemleri/grup-listesi/grup-listesi.ts